<template>
    <div class="page-header">
        <el-breadcrumb separator-class="el-icon-d-arrow-right">
            <el-breadcrumb-item>{{title.firstTitle}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="title.secondTitle">{{title.secondTitle}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="title.thirdTitle">{{title.thirdTitle}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="title.fourTitle">{{title.fourTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
<script>
export default {
    name: 'paperHeader',
    props:['title'],
    data() {
        return {

        }
    }
}
</script>
<style scoped>
.page-header {
    height: 60px;
}
/deep/ .el-breadcrumb__item .el-breadcrumb__inner {
    color:  #409eff;
    font-size: 16px;
    line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/PageHeader.vue